import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useAccountStorage } from '@juvare/contact-management/AppClients';
import { GetResponse } from '@juvare/platform-shared/features/storage';
import React from 'react';

export const useSelectedPerson = () => {
    const [person, setPerson] = React.useState<GetResponse<ExtendedAccountData, ExtendedAccountColumns>>();
    const storageClient = useAccountStorage();

    const handlePersonIdSelect = React.useCallback(
        async (personId: string, callback?: (newPerson: ExtendedAccountData) => void) => {
            return storageClient
                .get(personId)
                .then((person) => {
                    setPerson(person as GetResponse<ExtendedAccountData, ExtendedAccountColumns>);
                    callback?.(person.data as ExtendedAccountData);
                })
                .catch(handleErrorDialog);
        },
        [storageClient],
    );

    const handlePersonIdReset = React.useCallback(() => {
        setPerson(undefined);
    }, []);

    return React.useMemo(
        () => ({
            handlePersonIdReset,
            handlePersonIdSelect,
            person,
            selectedPersonId: person?.id,
        }),
        [handlePersonIdReset, handlePersonIdSelect, person],
    );
};
